import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Video from "../video/Video";
import Date from "./date";
import Scroll from "../Scroll"


const Intro = ({ setTheme }) => {

  const refWrapper = useRef();
  const refContent = useRef();
  const [isActive, setIsActive] = useState(false);
  const [wrapperHeight, setWrapperHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [videoIsEnded, setVideoIsEnded] = useState(false);


  function handleIntersect(entries, observer) {
    let el = entries[0].target;
    ( entries[0].intersectionRatio > 0 ) ? setIsActive(true) : setIsActive(false);
  }

  function setupObserver(el) {
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75]
    };
    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(el);
  }

  useEffect(() => {
    if ( refContent.current ) {
      setupObserver(refContent.current);
      setContentHeight(refContent.current.offsetHeight);
    }
    if ( refWrapper.current ) {
      setWrapperHeight(refWrapper.current.offsetHeight);
    }

  }, [])


  
  const [opacity, setOpacity] = useState(1);
  const [blur, setBlur] = useState(0);
  const requestRef = useRef();

  const buffer = 200;

  const animate = time => {
    if ( ! refContent.current || ! isActive || ! wrapperHeight ) {
      return;
    }

    const contentTop = refContent.current.offsetTop;
    
    let updatedOpacity = 1;
    let updatedBlur = 0;

    if ( contentTop > buffer ) {
      updatedOpacity = (1 + ((buffer - contentTop) / 100)).toFixed(2)
      updatedBlur = Math.ceil((1 - updatedOpacity) * 4)
    }
    /*
    else if ( contentTop > 0 && contentTop > buffer && wrapperHeight - contentHeight - contentTop < buffer ) {
      //updatedOpacity = 1 - ((buffer - ( multipliedOffsetHeight - contentTop )) / 100).toFixed(2)
      updatedOpacity = ((wrapperHeight - contentHeight - contentTop) / 100).toFixed(2)
      updatedBlur = Math.floor((1 - updatedOpacity) * 4)
    }*/
    else if ( contentTop > 0 && contentTop > buffer ) {
      updatedOpacity = 0;
      updatedBlur = 0;
    }

    setOpacity(prevOpacity => updatedOpacity);
    setBlur(prevBlur => updatedBlur );

    requestRef.current = requestAnimationFrame(animate);
  }
  
  useEffect(() => {
    if ( ! isActive ) {
      cancelAnimationFrame(requestRef.current);
    }
    else {
      requestRef.current = requestAnimationFrame(animate);
    }
  },[isActive])

  return (
    <>
      <StyledIntro ref={refWrapper}>
        <IntroVideo videoIsEnded={videoIsEnded} setVideoIsEnded={setVideoIsEnded} />
        <IntroTitle />
      </StyledIntro>
    </>
  )
}
export default Intro
export { Intro }


const StyledIntro = styled.div`
  position: relative;
  z-index: 1;
  background-color: var(--theme-background-dark);
  color: var(--theme-background-light);
  margin: 0 calc(-1 * var(--gutter)) calc(3.5 * var(--text-size));
  margin: 0 calc(-1 * var(--gutter));
  padding: 0 var(--gutter);
  text-align: center;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -50vw;
    width: 100vw;
    background-color: inherit;
    z-index: -1;
  }
`

const IntroVideo = ({ videoIsEnded, setVideoIsEnded }) => {
  const refContent = useRef();
  const [isActive, setIsActive] = useState(false);

  function handleIntersect(entries, observer) {
    let el = entries[0].target;
    ( entries[0].intersectionRatio > 0 ) ? setIsActive(true) : setIsActive(false);
  }

  function setupObserver(el) {
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75]
    };
    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(el);
  }

  useEffect(() => {
    if ( refContent.current ) {
      setupObserver(refContent.current);
    }

  }, [])


  
  const [opacity, setOpacity] = useState(1);
  const [blur, setBlur] = useState(0);
  const requestRef = useRef();

  const buffer = 200;

  const animate = time => {
    if ( ! refContent.current || ! isActive ) {
      return;
    }

    const contentTop = refContent.current.offsetTop;
    
    let updatedOpacity = 1;
    let updatedBlur = 0;

    if ( contentTop > buffer ) {
      updatedOpacity = (1 + ((buffer - contentTop) / 100)).toFixed(2)
      updatedBlur = Math.ceil((1 - updatedOpacity) * 4)
    }
    else if ( contentTop > 0 && contentTop > buffer ) {
      updatedOpacity = 0;
      updatedBlur = 0;
    }

    setOpacity(prevOpacity => updatedOpacity);
    setBlur(prevBlur => updatedBlur );

    requestRef.current = requestAnimationFrame(animate);
  }
  
  useEffect(() => {
    if ( ! isActive ) {
      cancelAnimationFrame(requestRef.current);
    }
    else {
      requestRef.current = requestAnimationFrame(animate);
    }
  },[isActive])

  return (
    <StyledIntroVideo ref={refContent} style={{
      "--opacity": opacity, 
      "--blur": `${blur}px`
    }}>
      <Video
        /*autoplay="autoplay"*/
        /*src="/video/al-mabani-migrant-prison.mp4"*/
        src="https://cdn.theoutlawocean.com/al-mabani/footage__al-mabani-migrant-prison.mp4"
        muted="muted"
        autoplay="autoplay"
        onEnded={() => setVideoIsEnded(true)}
        preload="auto"
        maxWidth="var(--figure-max-width)"
      />
      <figcaption>Al Mabani Detention Center, Tripoli, Libya</figcaption>
      <StyledScrollDown className={videoIsEnded ? 'is-visible' : undefined}>
        <Scroll />
      </StyledScrollDown>
    </StyledIntroVideo>
  )
}
const StyledIntroVideo = styled.figure`
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -100vh;
  margin-top: calc(-1 * (var(--navbar-height) + var(--titlebar-height) + 3em));
  opacity: var(--opacity);
  filter: blur(var(--blur));
  padding-top: 2em;
  max-width: var(--text-max-width);
  margin-right: auto;
  margin-left: auto;
  @media ( max-width: 48em ) {
    height: 90vh;
  }
  p {
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    font-size: 0.875em;
    text-transform: uppercase;
    color: var(--theme-text-against-dark-medium);
    margin: 0 0 2em;
    @media ( min-width: 60em ) {
      display: none;
    }
  }
  figcaption {
    margin-top: 1.375em;
    font-size: var(--text-size);
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    font-size: var(--text-size-large);
    font-family: var(--font-serif);
    font-weight: 400;
  }
  time {
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    margin-top: 0.5em;
    color: var(--theme-text-against-dark-medium);
  }
`

const StyledScrollDown = styled.span`
  position: absolute;
  display: block;
  width: 100%;
  text-align: center;
  bottom: calc(2.5 * var(--text-size));
  opacity: 0;
  color: var(--theme-text-against-dark-medium);
  transform: translate3d(0,0,0) scale(0.7);
  transition: opacity 0.2s ease, transform 0.3s ease;
  &.is-visible {
    transform: translate3d(0,0,0) scale(1);
    opacity: 1;
  }
`


const IntroTitle = () => {
  return (
    <StyledIntroTitle>
      <div>
        <h1>The Secretive Prisons<br /> That Keep Migrants Out<br /> of Europe</h1>
        <p>Tired of migrants arriving from Africa, the E.U. has created a shadow immigration system that captures them before they reach its shores, and sends them to brutal Libyan detention centers run by militias.</p>
        <cite>By Ian Urbina</cite>
        <Date dateString="November 28th, 2021" />
      </div>
    </StyledIntroTitle>
  )
}
const StyledIntroTitle = styled.header`
  position: relative;
  z-index: 1;
  background-color: var(--theme-background-dark);
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  padding: 0 var(--gutter);
  .js & {
    background-color: transparent;
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  h1 {
    position: relative;
    //font-family: var(--font-bold) !important;
    //font-size: 6em;
    font-size: 3.75em;
    //font-weight: var(--font-bold-weight) !important;
    //text-transform: uppercase !important;
    //line-height: 0.9 !important;
    //margin: 0 !important;
    text-align: center;
    color: var(--theme-text-against-dark);

    //letter-spacing: normal !important;

    font-family: var(--font-narrow);
    font-weight: 500;
    font-size: clamp(3em,10vw,6em);
    line-height: 1;
    margin: 0 auto 1em;

  }
 p {
    position: relative;
    font-family: var(--font-serif);
    font-weight: 400;
    font-style: italic;
    font-size: 1.375em;
    line-height: 1.3;
    max-width: 27em;
    margin: 1em auto;
    color: var(--theme-text-against-dark);
  /*
    -webkit-background-clip: text;
    color: transparent;
    background-image: linear-gradient(to bottom, var(--theme-background-dark), var(--theme-background-dark) 5%, var(--color-text-white), var(--theme-background-dark) 95%, var(--theme-background-dark));
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    */
  }
  cite {
    position: relative;
    font-size: 1.125em;
    font-weight: 600;
    font-family: var(--font-caption);
    font-style: normal;
    color: var(--theme-text-against-dark);
    /*
    -webkit-background-clip: text;
    color: transparent;
    background-image: linear-gradient(to bottom, var(--theme-background-dark), var(--theme-background-dark) 5%, var(--color-text-white), var(--theme-background-dark) 95%, var(--theme-background-dark));
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    */
  }
  time {
    margin-top: 1.5em;
  }
  @media ( max-width: 48em ) {
    h1 {
      font-size: 12vw;
      br {
        display: none;
      }
    }
    p {
      font-size: 1.25em;
    }
    cite {
      font-size: 1em;
    }
  }
`